import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';

@injectable()
export default abstract class AttachmentControlVM {
    isReady = ko.pureComputed(() => this.checkIfReady());
    isVisible = ko.pureComputed(() => this.checkIfVisible());

    constructor(
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        requestAnimationFrame(() => {
            ko.applyBindingsToNode(info.element, {
                'click': () => this.click(),

                'visible': this.isVisible,

                'css': {
                    'wcc-attachment-controls__control': true
                }
            });
        });
    }

    abstract click(): void

    protected checkIfReady() {
        return true;
    }

    protected checkIfVisible() {
        return true;
    }
}